module.exports = __webpack_public_path__ + "media/images/winery-the-shop-m-75112033750df12d8b21d9a43f8d46a0.jpg";